import { Box, Flex, Text } from '@chakra-ui/react'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'

const Header = ({ FeedbackEntry }) => {
    const [showDate, setShowDate] = useState(false)

    useEffect(() => {
        const isDifferentDate = !dayjs(FeedbackEntry.slot_start).isSame(
            dayjs(),
            'day'
        )
        setShowDate(isDifferentDate)
    }, [FeedbackEntry.slot_start])

    return (
        <Box display="flex" flexDirection="column" gap={2}>
            <Text fontSize="lg" fontFamily="Rubik" fontWeight={700}>
                How Was The Session?
            </Text>
            <Flex
                alignItems="center"
                textColor="gray"
                fontWeight="normal"
                fontSize="sm"
            >
                {showDate && (
                    <Text whiteSpace="nowrap">
                        {dayjs(FeedbackEntry.slot_start).format('DD MMM YYYY')}
                    </Text>
                )}
                <Text mx={showDate ? 2 : 0} whiteSpace="nowrap">
                    {`${dayjs(FeedbackEntry.slot_start).format(
                        'h:mm A'
                    )} - ${dayjs(FeedbackEntry.slot_end).format('h:mm A')}`}
                </Text>
                <Box
                    mx={3}
                    borderRadius="50%"
                    height={1}
                    width={1}
                    bg="scorpion2"
                    flexShrink={0}
                />
                <Text
                    whiteSpace="nowrap"
                    overflow="hidden"
                    textOverflow="ellipsis"
                    flex="1"
                >
                    {FeedbackEntry.course_name}
                </Text>
            </Flex>
        </Box>
    )
}

export default Header
